import React from "react";

function ArrowBack({ width = 24, height = 25, fill = "#7C6060" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_92182)">
        <path
          d="M20 11.5H7.83L13.42 5.91L12 4.5L4 12.5L12 20.5L13.41 19.09L7.83 13.5H20V11.5Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default ArrowBack;
